import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { IAuthState, IRootStore } from '../types';


const state: IAuthState = {
  isLoggedIn: false,
};

export const auth: Module<IAuthState, IRootStore> = {
  getters,
  actions,
  mutations,
  state,
};
